/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Setup method.
 */
export const SetIdentityProviderConnectionSetupMethodRequestBodyListingMode = {
  CustomApp: "custom_app",
  Oin: "oin",
} as const;
/**
 * Setup method.
 */
export type SetIdentityProviderConnectionSetupMethodRequestBodyListingMode =
  ClosedEnum<
    typeof SetIdentityProviderConnectionSetupMethodRequestBodyListingMode
  >;

export type SetIdentityProviderConnectionSetupMethodRequestBody = {
  /**
   * Connection ID.
   */
  id: string;
  /**
   * Setup method.
   */
  listingMode: SetIdentityProviderConnectionSetupMethodRequestBodyListingMode;
};

/** @internal */
export const SetIdentityProviderConnectionSetupMethodRequestBodyListingMode$outboundSchema:
  z.ZodMiniEnum<
    typeof SetIdentityProviderConnectionSetupMethodRequestBodyListingMode
  > = z.enum(SetIdentityProviderConnectionSetupMethodRequestBodyListingMode);

/** @internal */
export type SetIdentityProviderConnectionSetupMethodRequestBody$Outbound = {
  id: string;
  listing_mode: string;
};

/** @internal */
export const SetIdentityProviderConnectionSetupMethodRequestBody$outboundSchema:
  z.ZodMiniType<
    SetIdentityProviderConnectionSetupMethodRequestBody$Outbound,
    SetIdentityProviderConnectionSetupMethodRequestBody
  > = z.pipe(
    z.object({
      id: z.string(),
      listingMode:
        SetIdentityProviderConnectionSetupMethodRequestBodyListingMode$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        listingMode: "listing_mode",
      });
    }),
  );

export function setIdentityProviderConnectionSetupMethodRequestBodyToJSON(
  setIdentityProviderConnectionSetupMethodRequestBody:
    SetIdentityProviderConnectionSetupMethodRequestBody,
): string {
  return JSON.stringify(
    SetIdentityProviderConnectionSetupMethodRequestBody$outboundSchema.parse(
      setIdentityProviderConnectionSetupMethodRequestBody,
    ),
  );
}
